<template>
  <div class="camera-capture-container">
    <video v-show="!capturedImage" ref="video" autoplay class="camera-video"></video>
    <canvas v-show="false" ref="canvas"></canvas>
    <img v-if="capturedImage" :src="capturedImage" class="captured-image" />
    <div class="camera-controls">
      <PrimeButton v-if="!capturedImage" label="Capture" variant="primary" @click="capturePhoto" />
      <PrimeButton v-if="capturedImage" label="Retake" variant="secondary" @click="retakePhoto" class="p-btn-root_secondary" />
      <PrimeButton  v-if="capturedImage" label="Send" variant="primary" @click="sendPhoto" />
      <PrimeButton label="Cancel" variant="secondary" @click="cancel" class="p-btn-root_secondary" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useContactsStore } from '~/stores/person/contacts';

const store = useContactsStore();

const video = ref<HTMLVideoElement | null>(null);
const canvas = ref<HTMLCanvasElement | null>(null);
const capturedImage = ref<string | null>(null);
let stream: MediaStream | null = null;
const dialogRef = inject<{ value: { close: () => void } }>('dialogRef');

onMounted(async () => {
  try {
    stream = await navigator.mediaDevices.getUserMedia({ video: true });
    if (video.value) {
      video.value.srcObject = stream;
    }
  } catch (error) {
    console.error('Error accessing camera:', error);
  }
});

onUnmounted(() => {
  if (stream) {
    stream.getTracks().forEach(track => track.stop());
  }
});

const capturePhoto = () => {
  if (!video.value || !canvas.value) return;
  
  const context = canvas.value.getContext('2d');
  if (!context) return;
  
  canvas.value.width = video.value.videoWidth || 0;
  canvas.value.height = video.value.videoHeight || 0;
  context.drawImage(video.value, 0, 0, canvas.value.width, canvas.value.height);
  capturedImage.value = canvas.value.toDataURL('image/jpeg');
};

const retakePhoto = () => {
  capturedImage.value = null;
};


const sendPhoto = () => {
  if (capturedImage.value && dialogRef?.value) {
    store.capturedPhoto = capturedImage.value;
    dialogRef.value.close();
  }
};

const cancel = () => {
  capturedImage.value = null;
  dialogRef?.value?.close();
};
</script>

<style lang="scss" scoped>
.camera-capture-container {
  @apply flex flex-col items-center gap-4 p-4 bg-white max-w-screen-md mx-auto overflow-y-auto max-h-screen scale-90;
}

.camera-video,
.captured-image {
  @apply w-full h-auto rounded;
}

.camera-controls {
  @apply flex gap-3;
}
</style>